module.exports = __webpack_public_path__ + "static/media/teaser-b.4ce286ed.png";